import { setUserDeleteModalOpen } from "pages/UserManagement/userSlice";
import { useDispatch, useSelector } from "react-redux";
import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function DeleteUser({ selectedData, handleDeleteNotification, data }) {
  const dispatch = useDispatch();
  const { userDeleteModalOpen, deleteUserLoading } = useSelector(
    (state) => state.counsilor
  );

  const handleDelete = () => {
    handleDeleteNotification(data);
  };

  return (
    <ModalComp
      title="Delete Councillor"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => dispatch(setUserDeleteModalOpen(false))}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={deleteUserLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="danger"
          secondaryBtnText="Delete"
        />
      }
      open={userDeleteModalOpen}
      setOpen={(Value) => dispatch(setUserDeleteModalOpen(Value))}
    >
      {`Are you sure you want to delete the councillor named '${selectedData?.first_name} ${selectedData?.last_name}'`}
    </ModalComp>
  );
}

export default DeleteUser;
